import { z } from "zod";

export const ManutencaoEquipObraSchema = z.object({
  idManutencaoEquipObra: z.number().nullable().optional(),
  idObra: z.number().nullable().optional(),
  descricao: z.string().nullable().optional(),
  dataManutencao: z.coerce.date().nullable().optional(),
  dataProxManutencao: z.coerce.date().nullable().optional(),
  parteEletrica: z.string().nullable().optional(),
  parteMecanica: z.string().nullable().optional(),
  lubrificacao: z.string().nullable().optional(),
  limpeza: z.string().nullable().optional(),
  observacao: z.string().nullable().optional(),
  outros1: z.string().nullable().optional(),
  outros2: z.string().nullable().optional(),
  delete: z.boolean().nullable().optional(),
  status: z.boolean().optional().default(false),
  dataPrevDevolucao: z.coerce.date().nullable().optional(),
  idFornecedor: z.number().nullable().optional(),
  descLocatario: z.string().nullable().optional(),
  statusDevolucao: z.boolean().nullable().optional().default(false),
  dataDevolucao: z.coerce.date().nullable().optional(),

});

export type ManutencaoEquipObraForm = z.infer<typeof ManutencaoEquipObraSchema>;

export const defaultManutencaoEquipObraForm: Partial<ManutencaoEquipObraForm> = {
  idManutencaoEquipObra: undefined,
  idObra: undefined,
  descricao: "",
  dataManutencao: undefined,
  dataProxManutencao: undefined,
  parteEletrica: "",
  parteMecanica: "",
  lubrificacao: "",
  limpeza: "",
  observacao: "",
  outros1: "",
  outros2: "",
  delete: false,
  status: false,
  dataPrevDevolucao: undefined,
  idFornecedor: undefined,
  descLocatario: "",
  statusDevolucao: false,
  dataDevolucao: undefined,
};


